export default "__VITE_ASSET__BxsRHBkG__"